/**
 * @file Expandable Content.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Expandable Content component.
 */
const vExpandableContent = () => {
	const expandableContent = document.querySelectorAll('.v-expandable-content');

	if (!expandableContent.length) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	/**
	 * Get all subsequent elements.
	 *
	 * @param {HTMLElement} e - Current element.
	 * @param {string} selector - Selector.
	 * @yields {HTMLElement} - Subsequent element.
	 */
	function* vNextAll(e, selector) {
		while (e = e.nextElementSibling) { // eslint-disable-line no-cond-assign, no-param-reassign
			if (e.matches(selector)) {
				yield e;
			}
		}
	}

	const footer = document.querySelector('.v-footer');
	let isExpanding = false;

	[...expandableContent].forEach((block) => {
		const wrapper = block.querySelector('.v-expandable-content__wrapper');
		const trigger = block.querySelector('.v-expandable-content__trigger');
		const triggerIcon = block.querySelector('.v-expandable-content__trigger-icon');
		const expandable = block.querySelector('.v-expandable-content__expandable');
		const nextAll = [...vNextAll(block, '*'), footer];

		trigger.addEventListener('click', () => {
			if (isExpanding) return;
			isExpanding = true;

			const currentHeight = wrapper.offsetHeight;
			expandable.classList.add('v-expandable-content__expandable--expanded');
			wrapper.classList.add('v-expandable-content__wrapper--expanded');
			const targetHeight = wrapper.offsetHeight;
			wrapper.classList.remove('v-expandable-content__wrapper--expanded');
			gsap.set(nextAll, { y: currentHeight - targetHeight });

			gsap.timeline({
				defaults: {
					duration: 0.4,
					ease:     'sine.out',
				},
				onUpdate: () => {
					ScrollTrigger.refresh();
				},
				onComplete: () => {
					trigger.classList.add('v-expandable-content__trigger--expanded');
					wrapper.classList.add('v-expandable-content__wrapper--expanded');
					nextAll.forEach((e) => { e.removeAttribute('style'); });
					isExpanding = false;
				},
			})
				.to(nextAll, {
					y: 0,
				})
				.to(wrapper, {
					'--height': targetHeight,
				}, '<')
				.to(triggerIcon, {
					opacity: 0,
				}, '<');
		});
	});
};

export default vExpandableContent;
